/**
 * Proporção largura:altura da foto de capa (banner) do perfil público.
 * Compartilhada entre o editor (enquadramento/recorte) e a página do cliente
 * (render) — precisam ser idênticas para o recorte salvo aparecer sem
 * re-corte do `resizeMode="cover"`. Módulo leve de propósito: a página pública
 * (sem login) não deve importar o editor e arrastar reanimated/gesture-handler.
 */
export const COVER_ASPECT = 2.5;
